import React from 'react';

import { nanoid } from 'nanoid';
import cn from 'class-names';

import { SVGIcon, SvgIconType } from '@uikit/old/Icon/Icon';
import ReactTooltip, { Place } from 'react-tooltip';

import './QuestionTooltip.scss';

type QuestionTooltipType = {
  text: string | React.ReactNode;
  color?: string;
  offset?: { [key in 'left' | 'right' | 'bottom' | 'top']?: number };
  style?: React.CSSProperties;
  icon?: SvgIconType;
  place?: Place;
  children?: React.ReactNode;
  isLightTheme?: boolean;
  width?: string;
};

const QuestionTooltip = ({
  text,
  color,
  offset,
  style,
  icon = 'questionInCircleFilled',
  place = 'bottom',
  children,
  isLightTheme = false,
  width,
}: QuestionTooltipType): JSX.Element => {
  const uniqueId = nanoid();
  const cnTooltip = cn('react-tooltip question-tooltip__react-tooltip', {
    'react-tooltip question-tooltip__react-tooltip without-after': offset,
  });
  const cnBodyTooltip = cn('question-tooltip__text', {
    'question-tooltip__is-light-theme': isLightTheme,
  });
  return (
    <div className="question-tooltip" style={style}>
      <span className="question-tooltip__svg-wrapper" data-for={uniqueId} data-tip="">
        {icon ? <SVGIcon icon={icon} color={color} /> : children}
      </span>
      <ReactTooltip
        id={uniqueId}
        className={cnTooltip}
        place={place}
        effect="solid"
        offset={offset}
        arrowColor="transparent"
      >
        <div className={cnBodyTooltip} style={{ width, maxWidth: width }}>
          {text}
        </div>
      </ReactTooltip>
    </div>
  );
};

export default QuestionTooltip;
